import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router'
import Nodes from './pages/Nodes.tsx'
import './index.css'
import { ClerkProvider, SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react'
import {
  QueryClientProvider,
} from '@tanstack/react-query'

import Subscription from './pages/Subscription.tsx'
import Settings from './pages/Settings.tsx'
import Layout from './Layout.tsx'
import { queryClient } from './utils/query.ts'
import Node from './pages/Node.tsx'
import NotFound from './pages/NotFound.tsx'

import './i18n.ts'

// Import your Publishable Key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <QueryClientProvider client={queryClient}>
          <SignedIn>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Nodes />} />
                <Route path="nodes" element={<Nodes />} />
                <Route path="nodes/:id" element={<Node />} />
                <Route path="subscription" element={<Subscription />} />
                <Route path="settings" element={<Settings />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </QueryClientProvider>
      </ClerkProvider>
    </BrowserRouter>
  </React.StrictMode>,
)